module.exports = __webpack_public_path__ + "img/calculator-circle.002b645c.svg";